'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, children, required, ...rest }, ref) => {
    return (
      <label
        ref={ref}
        className={cn('block text-sm font-medium text-text-primary mb-1.5', className)}
        {...rest}
      >
        {children}
        {required && <span className="text-status-busy ml-0.5">*</span>}
      </label>
    );
  }
);
Label.displayName = 'DsLabel';
